export default {"src":"/_next/static/media/clipboardWithCross_64.30157a6a.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};